import { saveCartToLocal } from '@/utils/cart';

/**
 * Middleware to sync cart state to localStorage
 * This ensures localStorage is always in sync with Redux state
 */
export const cartSyncMiddleware = (store) => (next) => (action) => {
  const result = next(action);
  
  // Only sync cart-related actions (skip pending actions to avoid race conditions)
  // Exclude syncFromLocalStorage to prevent infinite loops (it reads FROM localStorage, not TO)
  if (
    action.type?.startsWith('cart/') && 
    !action.type?.endsWith('/pending') &&
    action.type !== 'cart/syncFromLocalStorage'
  ) {
    try {
      const state = store.getState();
      const cartItems = state.cart.items;
      
      // Always save to localStorage to keep it in sync
      // This includes empty arrays (when cart is cleared) and populated arrays
      if (Array.isArray(cartItems)) {
        saveCartToLocal(cartItems);
        
        // Dispatch custom event for components that still listen to it
        // Note: syncFromLocalStorage is excluded to prevent infinite loops
        window.dispatchEvent(new Event('cartUpdated'));
      }
    } catch (error) {
      console.error('Error in cart sync middleware:', error);
      // Don't throw - middleware errors shouldn't break the app
    }
  }
  
  return result;
};

